import { OtpInfoDto } from '../../../../api/gen';

export class OtpInfo {
  credentialId?: string | null;

  static fromDto(dto: OtpInfoDto): OtpInfo {
    return { credentialId: dto.credentialId } as OtpInfo;
  }
}
